<div class="card-body d-flex justify-content-between align-items-center p-0">
  <ng-content></ng-content>
</div>
